import EventExplorer from "./components/EventExplorer";


function Home() {
  return (
    <div className="max-w-[1300px] mx-auto">
      <EventExplorer />
    </div>
  );
}

export default Home;
